import React, { createContext, useContext, useState, useEffect } from 'react';

const SidebarContext = createContext();

export const useSidebar = () => {
  const context = useContext(SidebarContext);
  if (!context) {
    throw new Error('useSidebar must be used within a SidebarProvider');
  }
  return context;
};

export const SidebarProvider = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkMobile = () => {
      // Detectar móvil: ancho < 768 O (altura < 500 para landscape móvil)
      // También verificar si es un dispositivo táctil en landscape
      const isSmallWidth = window.innerWidth < 768;
      const isLandscapeMobile = window.innerHeight < 500 && window.innerWidth < 1024;
      const isMobileDevice = isSmallWidth || isLandscapeMobile;
      
      setIsMobile(isMobileDevice);
      
      // Cerrar sidebar si cambiamos a desktop
      if (!isMobileDevice) {
        setIsOpen(false);
      }
    };

    checkMobile();
    window.addEventListener('resize', checkMobile);
    window.addEventListener('orientationchange', checkMobile);
    
    return () => {
      window.removeEventListener('resize', checkMobile);
      window.removeEventListener('orientationchange', checkMobile);
    };
  }, []);

  const toggleSidebar = () => setIsOpen(!isOpen);
  const closeSidebar = () => setIsOpen(false);

  return (
    <SidebarContext.Provider value={{ isOpen, isMobile, toggleSidebar, closeSidebar }}>
      {children}
    </SidebarContext.Provider>
  );
};
